import React from "react";

const TemplateValue = {
    template: {},
    updateTemplate: () => {},
};

const TemplateContext = React.createContext(TemplateValue);
export default TemplateContext;
